export const QUERY_KEY = {
  getAllLeagues: "allLeague",
  createLeague: "league",
  updateLeague: "updateLeague",
  getTournamentsByLeagues: `getTournamentsByLeagueId`,
  /** GET /league/teamSnapshot/{leagueId} — tournaments and team snapshots for the league */
  leagueTeamSnapshot: "league/teamSnapshot",
  getMatchesByLeagueIdAndStatus: `getMatchesByLeagueIdAndStatus`,
  getDivisions: `getDivisions`,
  getCombinedPointsTableByDivision: "getCombinedPointsTableByDivision",
  getPointsTableByDivision: "getPointsTableByDivision",
  getLeagueStatsSummary: "getLeagueStatsSummary",
  websearch: "websearch",
  getLeagueStats: "getLeagueStats",
  getLeagueDetails: "league",
  /** GET `league/{leagueId}/players/search?search=&tournamentId=&teamSnapshotId=&role=&page=&size=` — Players-tab card grid */
  leaguePlayersSearch: "league",
  /** GET `league/duplicatePlayers/groups?leagueId=` */
  leagueDuplicatePlayerGroups: "league/duplicatePlayers/groups",
  /** POST `league/duplicatePlayers/preview` — body: { leagueId, keepPlayerId, mergePlayerIds } */
  leagueDuplicatePlayerPreview: "league/duplicatePlayers/preview",
  /** POST `league/duplicatePlayers/merge` — body: { leagueId, keepPlayerId, mergePlayerIds, overrides? } */
  leagueDuplicatePlayerMerge: "league/duplicatePlayers/merge",
  addTournament: "tournament",
  updateTournament: "updateTournament",
  /** GET/POST `league/{leagueId}/waiver` — league waiver forms, used for the tournament "Select Waiver Form" dropdown */
  leagueWaivers: "league",
  /** GET `tournament/{tournamentId}/my-waiver-status`; GET/POST `tournament/{tournamentId}/waiver-signature[/{playerId}]` */
  tournamentWaiverSignature: "tournament",
  matchByTournamentIdAndStatusPageable: "matchByTournamentIdAndStatusPageable",

  //Teams
  getAllTeam: "teamv2",
  teamsSnapShotByTeamId: "teamsSnapShotByTeamId",
  getAllPlayers: "playersByTeamSnapshotId",
  getTeamPlayerStats: "getTeamPlayerStats",
  matchByTeamAndStatus: "matchByTeamAndStatus",
  matchByTeam: "matchByTeam",
  getPlayerProfile: "getPlayerProfile",
  getAllPlayersByLeague: "searchPlayersByLeague",
  getPlayersByTournament: "getPlayersByTournament",
  searchPlayersByNameForLeague: "searchPlayersByNameForLeague",
  getTeamsByTeamAdminId: "teamsByTeamAdminId",
  createNewTeamByPlayer: "createNewTeamByPlayer",
  updateTeam: "updateTeam",
  /** PUT `updateTeamByPlayer/{teamId}` — body: { teamName, teamCode?, description? } (My Team only) */
  updateTeamByPlayer: "updateTeamByPlayer",
  getMyTeamPlayers: "getAllPlayers",
  createDivision: "division",
  updateDivision: "division",
  checkDuplicatesInLeague: "checkDuplicatesInLeague",
  teamPlayersJoinAndAttachToLeague: "teamPlayersJoinAndAttachToLeague",
  searchPlayer: "player/search",
  updatePlayerV2: "player/v2",
  assignCoAdmin: "assignCoAdmin",
  removeCoAdmin: "removeCoAdmin",
  removePlayerFromTeamSnapshot: "removePlayerFromTeamSnapshot",
  /** POST /addPlayerToTeamSnapshot/{teamSnapshotId}/{playerId} — attach a single existing player to a team snapshot */
  addPlayerToTeamSnapshot: "addPlayerToTeamSnapshot",
  searchTournamentByName: "searchTournamentByName",
  joinTournamentAsATeam: "JoinTournamentAsATeam",
  /** GET /tournament/leaderboard?tournamentId=&filter=BATTING|BOWLING|... */
  tournamentLeaderboard: "tournament/leaderboard",
  /** GET getTournamentStats?tournamentId=&topN= — tournament stats (cards / full list) */
  getTournamentStats: "getTournamentStats",
  /** GET tournament/teams?tournamentId= — teams participating in a tournament */
  tournamentTeams: "tournament/teams",

  //Matches-Details
  getMatchInfo: "match",
  getCommentary: "getlastNoversSummary",
  getRecentStats: "getRecentStats?inningId=1bc3cf1d-1474-4233-8f9d-19f2edd7e72d",
  getTeamSquadForMatch: "getTeamSquadForMatch",
  getScoreByMatch: "getScoreByMatch",
  matchAnalysis: "matchAnalysis/50029425-3626-420b-b338-79ffe641a09c",
  showGraphics: "showGraphics",
  searchLeagueByName: "searchLeagueByName",
  matchByTournament: "matchByTournament",
  getPlayerProfileById: "getPlayerProfile/playerId",
  getPlayerStats: "playerStats",
  batsmanVsBowler: "batsmanVsBowler",

  //auth api's
  getUserNamesByEmail: "getUserNamesByEmail",
  isUserExist: "/newUser/checkAvailability",

  //Grounds
  createGround: "ground",
  updateGround: "updateGround",
  deleteGround: "deleteGround",
  groundsByLeagueId: "groundsByLeagueId",
  getGroundDetails: "ground",
  generateBulkGroundUploadExcelTemplate: "generateBulkGroundUploadExcelTemplate",
  generateBulkTeamUploadFileForTournament: "generateBulkTeamUploadFileForTournament",
  generatePlayerUploadFileForTournamentId: "generatePlayerUploadFileForTournamentId",
  bulkUploadPlayersForTeams: "bulkUploadPlayersForTeams",
  bulkUploadGround: "bulkUploadGround",
  bulkDivisionUpload: "bulkDivisionUpload",
  getAllGalleryForLeagues: "getAllGalleryForPlayer",
  getAllGalleryForTournaments: "getAllGalleryForPlayer",
  createGallery: "createGallery",
  multiplecreateGallery: "multiplecreateGallery",
  deleteGalleryImage: "deleteGalleryImage",
  getAllDocs: "getAllDocs",
  createDocs: "createDocs",

  //Statbot
  statGptSendMessage: "stat-gpt/send-message",
  statGptGetMessage: "stat-gpt/chat/message",
  statGptGetUserMessageHistory: "stat-gpt/getUserMessageHistory",
  statGptGetChatMessages: "stat-gpt/chat",
  statGptGeneratePresignedUrl: "stat-gpt/file/generatePresignedUrl",

  //Subscriptions
  getSubscriptionPlans: "/subscriptions/plans",
  createCheckoutSession: "/subscriptions/checkout",
  getCheckoutState: "/subscriptions/checkout/state",

  // League join requests (Player/Umpire/Scorer)
  createAutoSchedule: "createAutoSchedule",
  matchesBulk: "matches/bulk",
  scheduleMatch: "scheduleMatch",
  getJoinLeagueRequests: "getJoinLeagueRequests",
  getUmpireRequestsForLeague: "league/umpire",
  getScorerRequestsForLeague: "league/scorer",
  getAvailableUmpires: "league/availableUmpires",
  getAvailableScorers: "league/availableScorers",
  getTickerConfigTypes: "getTickerConfigTypes",
  getMatchTickerConfig: "ticker-config",
  tournamentTickerConfig: "tournament",
  getProfileClaimsByLeagueId: "getProfileClaimsByLeagueId",
  updatePlayerRoleDetails: "/player/roles/details",
  bulkChangeStatusOfUmpire: "league/bulkChangeStatusOfUmpire",
  bulkChangeStatusOfScorer: "league/bulkChangeStatusOfScorer",
  bulkChangeStatusOfPlayer: "league/bulkChangeStatusOfPlayer",
  /** PUT `assignRoleToPlayerInLeague?leagueId=&playerId=&roleName=` — no body */
  assignRoleToPlayerInLeague: "assignRoleToPlayerInLeague",
  /** POST `claimPlayerInLeague?leagueId=&unClaimedPlayerId=` — body {}; requester resolved from auth token */
  claimPlayerInLeague: "claimPlayerInLeague",
  /** POST `approvePlayerClaim?leagueId=&unclaimedPlayerId=&requestPlayerId=` — body {} */
  approvePlayerClaim: "approvePlayerClaim",
  /** POST `rejectPlayerClaim?leagueId=&unclaimedPlayerId=&requestPlayerId=` — body {} */
  rejectPlayerClaim: "rejectPlayerClaim",
};

/** How many overs each `getlastNoversSummary` call should return (backend must honor this param). */
export const COMMENTARY_OVERS_PER_REQUEST = 5;

export type CommentaryApiType = "FULLCOMMENTARY" | "SHORTCOMMENTARY" | "BOUNDARIES" | "WICKETS" | "BATSMAN";

/** `getlastNoversSummary` — matches production: overNumber=-1, isLatest=true */
export const getLastNoversSummaryLatestQueryParams = {
  overNumber: -1,
  isLatest: true,
  commentaryType: "FULLCOMMENTARY" satisfies CommentaryApiType,
  noOfOvers: COMMENTARY_OVERS_PER_REQUEST,
} as const;

/** Latest page params with optional commentary style and playerId (for BATSMAN filter). */
export function getLastNoversSummaryLatestParams(commentaryType: CommentaryApiType = "FULLCOMMENTARY", playerId?: string | null) {
  return {
    overNumber: -1,
    isLatest: true,
    commentaryType,
    noOfOvers: COMMENTARY_OVERS_PER_REQUEST,
    ...(commentaryType === "BATSMAN" && playerId ? { playerId } : {}),
  };
}

/** Older overs chunk: `isLatest=false`, anchor `overNumber` (e.g. min loaded over − 1). */
export function getLastNoversSummaryOlderQueryParams(overNumberAnchor: number, commentaryType: CommentaryApiType = "FULLCOMMENTARY", playerId?: string | null) {
  return {
    overNumber: overNumberAnchor,
    isLatest: false,
    commentaryType,
    noOfOvers: COMMENTARY_OVERS_PER_REQUEST,
    ...(commentaryType === "BATSMAN" && playerId ? { playerId } : {}),
  };
}
